<template>
    <div>
        <span v-if="isCollapse">
            <el-collapse
                v-model="activeCollapse"
                class="pt-2"
            >
                <el-collapse-item
                    :title="$t('settings.time.frame')"
                    name="timeFrame"
                >
                    <slot name="frame-types" />
                    <div
                        v-if="getComponent !== 'TimePeriod'"
                        class="w-80"
                    >
                        <label class="main-text-color">{{ $t('widget.time.interval') }}</label>
                        <component
                            :is="getComponent"
                            v-bind="$attrs"
                            range-separator="-"
                        />
                    </div>
                    <div v-else>
                        <component
                            :is="getComponent"
                            v-bind="$attrs"
                        />
                    </div>
                </el-collapse-item>
            </el-collapse>
        </span>
        <span v-else>
            <slot name="frame-types" />
            <div
                v-if="getComponent !== 'TimePeriod'"
                class="w-80"
            >
                <label class="main-text-color">{{ $t('widget.time.interval') }}</label>
                <component
                    :is="getComponent"
                    v-bind="$attrs"
                    class="w-80"
                />
            </div>
            <div v-else>
                <component
                    :is="getComponent"
                    v-bind="$attrs"
                    class=""
                />
            </div>
            {{ getComponent }}
        </span>
    </div>
</template>
<script>
import { Collapse, CollapseItem } from 'element-ui'
import { capitalizeFirstLetter } from '@/helpers/util'

export default {
    name: 'WidgetTimeFrame',
    components: {
        TimeAbsolute: () => import('./TimeAbsolute.vue'),
        TimeRelative: () => import('./TimeRelative.vue'),
        TimePeriod: () => import('./TimePeriod.vue'),
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
    },
    props: {
        timeFrameType: {
            type: String,
            default: 'relative'
        },
        isCollapse: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            activeCollapse: 'timeFrame',
        }
    },
    computed: {
        getComponent () {
            return 'Time' + capitalizeFirstLetter(this.timeFrameType)
        }
    }
}
</script>
